import tunnel from "tunnel-rat";

export const arrowTunnel = tunnel();
